import { render, staticRenderFns } from "./tama.vue?vue&type=template&id=d3608f48&scoped=true&"
import script from "./tama.vue?vue&type=script&lang=js&"
export * from "./tama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3608f48",
  null
  
)

export default component.exports